module.exports = __webpack_public_path__ + "static/media/CustomerService.53d292ba.svg";